import React, { useEffect, useMemo, useState } from 'react';
import styles from './PricingPage.module.less';
import TextureNoise from '@/assets/logo.png';
import closeIcon from '@/assets/project/closewhite.png';
import { infoController } from '@/api';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const PricingPage = (props) => {
  const [cycle, setCycle] = useState('monthly'); // 'monthly' | 'annually' | 'expansion'
  const userInfo = useSelector((state) => state.userInfo);
  const { t } = useTranslation();

  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const subscriptionIds = [
    {
      level: 'Free',
      subscriptionId: 1,
    },
    {
      level: 'Starter',
      cycle: 'monthly',
      subscriptionId: 2,
    },
    {
      level: 'Starter',
      cycle: 'annually',
      subscriptionId: 4,
    },
    {
      level: 'Creator',
      cycle: 'monthly',
      subscriptionId: 8,
    },
    {
      level: 'Creator',
      cycle: 'annually',
      subscriptionId: 16,
    },
  ];
  const includes = [
    [
      'Unlimited Texture Generation',
      '1 Model Generation',
      '4K Texture Resolution',
      '7 Days Cloud Storage',
      'Standard Support',
    ],
    [
      'Unlimited Texture Generation',
      '3 Models Generation',
      '10 Textures Export',
      '4K Texture Resolution',
      '180 Days Cloud Storage',
      'Priority Support',
    ],
    [
      'Unlimited Texture Generation',
      '5 Models Generation',
      '25 Textures Export',
      '4K Texture Resolution',
      'Permenant Cloud Storage',
      'Priority Support',
    ],
    [
      'Unlimited Texture Generation',
      'Unlimited Model Generation',
      'Unlimited Texture Export',
      '4K Texture Resolution',
      'Unlimited Cloud Storage',
      'Dedicated Account Manager',
      'API / SDK docking',
      'Private Deployment',
    ],
  ];

  const bagsIncludes = [
    [
      'Unlimited Texture Generation',
      '3 Models Generation',
      '10 Textures Export',
      '4K Texture Resolution',
      '180 Days Cloud Storage',
      'Priority Support',
    ],
    [
      'Unlimited Texture Generation',
      '5 Models Generation',
      '25 Textures Export',
      '4K Texture Resolution',
      'Permenant Cloud Storage',
      'Priority Support',
    ],
    [],
    [],
  ];

  useEffect(() => {
    query();
  }, [cycle]);

  const query = async () => {
    setLoading(true);
    setPlans([]);
    if (cycle === 'monthly' || cycle === 'annually') {
      const res = await infoController.infoPlans({});
      if (res.code == 0) {
        setPlans(res.data);
      }
    } else {
      const res = await infoController.fuelBags({});
      if (res.code == 0) {
        setPlans(res.data);
      }
    }
    setLoading(false);
  };

  const features = [
    {
      name: '3D Model Generation',
      vals: ['1', '3', '5', 'Unlimited'],
    },
    {
      name: 'Texture Generation',
      vals: ['Unlimited', 'Unlimited', 'Unlimited', 'Unlimited'],
    },
    {
      name: 'Texture Export',
      vals: ['0', '10', '25', 'Unlimited'],
    },
    {
      name: 'Texture Resolution',
      vals: ['Up to 4K', 'Up to 4K', 'Up to 4K', 'Up to 4K'],
    },
    {
      name: 'Cloud Storage',
      vals: ['7 Days', '180 Days', 'Permanent (limited time)', 'Unlimited'],
    },
    {
      name: 'API/SDK Docking',
      vals: ['✖', '✖', '✖', '✔'],
    },
    {
      name: 'Private Deployment',
      vals: ['✖', '✖', '✖', '✔'],
    },
    {
      name: 'Customer Support',
      vals: [
        'Submit a Support Ticket',
        'Priority Support',
        'Priority Support',
        'Dedicated Account Manager',
      ],
    },
  ];
  const getStart = async (p) => {
    let priceId = null;
    let subscriptionPeriod = undefined;
    let type = null;
    switch (cycle) {
      case 'monthly':
        priceId = p.monthlyPriceId;
        subscriptionPeriod = 0;
        type = 0;
        break;
      case 'annually':
        priceId = p.yearlyPriceId;
        subscriptionPeriod = 1;
        type = 0;
        break;
      case 'expansion':
        priceId = p.priceId;
        subscriptionPeriod = 0;
        type = p.number === 1 ? 2 : 1;
        break;
    }
    let res = await infoController.checkout({
      type: type, //支付类型 0: 订阅, 1: 加油包, 2: 单次购买
      priceId: priceId, // 价格id，从/info/plans或者/info/fuel-bags返回的参数中取priceId
      subscriptionPeriod: subscriptionPeriod, //订阅的类型 0: 月费, 1: 年费
    });
    if (res.code == 0) {
      window.open(res.data);
    }
  };
  const purchase = async (p) => {
    let res = await infoController.checkout({
      type: p.number === 1 ? 2 : 1, //支付类型 0: 订阅, 1: 加油包, 2: 单次购买
      priceId: p.priceId, // 价格id，从/info/plans或者/info/fuel-bags返回的参数中取priceId
      subscriptionPeriod: 0, //订阅的类型 0: 月费, 1: 年费
    });
    if (res.code == 0) {
      window.open(res.data);
    }
  };

  const isEnable = (level) => {
    const subscriptionId = userInfo.subscriptionId; // 1免费, 2:starter 月 , 4:starter 年 ,8:creater 月,16:creater 年
    if (level === 'Free') {
      return false;
    } else if (level === 'Starter') {
      if (cycle === 'monthly') {
        if (subscriptionId >= 2) {
          return false;
        } else {
          return true;
        }
      } else if (cycle === 'annually') {
        if (subscriptionId == 4 || subscriptionId === 16 || subscriptionId === 8) {
          return false;
        } else {
          return true;
        }
      }
    } else if (level === 'Creator') {
      if (cycle === 'monthly') {
        if (subscriptionId == 8 || subscriptionId == 4 || subscriptionId == 16) {
          return false;
        } else {
          return true;
        }
      } else if (cycle === 'annually') {
        if (subscriptionId == 16) {
          return false;
        } else {
          return true;
        }
      }
    }
    return false;
  };
  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <img
          src={TextureNoise}
          onClick={() => {
            window.location.href =
              window.location.protocol +
              '//' +
              window.location.host +
              '/home?random=' +
              new Date().getTime();
            // navigate('/');
            // setTimeout(() => {
            //   window.location.reload(true);
            // });
          }}
          className={styles.logo}
          alt=""
        />
        <img
          src={closeIcon}
          onClick={() => {
            props.close();
          }}
          className={styles.close}
          alt=""
        />
      </div>
      <h1 className={styles.title}>{t('app.pricing')}</h1>
      <p className={styles.subtitle}>{t('app.pricingSubtitle')}</p>

      <div className={styles.tabs}>
        <button
          className={`${styles.tab} ${cycle === 'monthly' ? styles.active : ''}`}
          onClick={() => !loading && setCycle('monthly')}>
          {t('app.monthly')}
        </button>
        <button
          className={`${styles.tab} ${cycle === 'annually' ? styles.active : ''}`}
          onClick={() => !loading && setCycle('annually')}>
          {t('app.annually')}
        </button>
        <button
          className={`${styles.tab} ${cycle === 'expansion' ? styles.active : ''}`}
          onClick={() => !loading && setCycle('expansion')}>
          {t('app.expansion')}
        </button>
      </div>

      {cycle === 'monthly' && <div className={styles.switchTip}>{t('app.saveAnnually')}</div>}
      {loading && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Spin></Spin>
        </div>
      )}

      <div className={cycle === 'expansion' ? styles.expansioncards : styles.cards}>
        {plans.map((p, index) => (
          <div key={p.id} className={styles.card}>
            {p.highlight && <div className={styles.badge}>{p.highlight}</div>}
            <div className={styles.cardHeader}>
              <div className={styles.cardTitle}>
                {p.level === 'Free' ? t('app.standard') : p.level}
              </div>
              {p.annualFee === -1 ? (
                <div className={styles.cardPrice}>{t('app.contactUs')}</div>
              ) : cycle === 'expansion' ? (
                <div className={styles.cardPrice}>${p.price}</div>
              ) : (
                <div className={styles.cardPrice}>
                  ${cycle === 'monthly' ? p.monthlyFee : (p.annualFee / 12).toFixed(1)}
                  <span className={styles.month}>/{t('app.month')}</span>
                </div>
              )}

              {p.annualFee === -1 ? (
                <a
                  className={styles.cta}
                  href="https://docs.google.com/forms/d/e/1FAIpQLScH-sob8IRghi6DB2FHxY5UDxcz-DEelUlod7Ci5P7CkECfwA/viewform"
                  target="_blank">
                  {t('app.contactUs')}
                </a>
              ) : cycle === 'expansion' ? (
                <button
                  className={`${styles.cta} ${userInfo.subscriptionId > 1 || p.number == 1 ? '' : styles.disable}`}
                  onClick={() => {
                    if (userInfo.subscriptionId > 1 || p.number == 1) {
                      getStart(p);
                    }
                  }}>
                  {t('app.purchase')}
                </button>
              ) : (
                <button
                  className={`${styles.cta} ${!isEnable(p.level) ? styles.disable : ''}`}
                  onClick={() => {
                    if (isEnable(p.level)) {
                      getStart(p);
                    }
                  }}>
                  {t('app.getStarted')}
                </button>
              )}
            </div>

            <div className={styles.divider} />

            <div className={styles.including}>{t('app.including')}</div>
            <ul className={styles.list}>
              {(cycle === 'expansion' ? bagsIncludes[index] : includes[index]).map((f, i) => (
                <li key={i} className={styles.listItem}>
                  <div className={styles.dot} /> {f}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <h2 className={styles.featuresTitle}>{t('app.featuresComparison')}</h2>

      <div className={styles.table}>
        <div className={`${styles.tr} ${styles.header}`}>
          <div className={styles.th}></div>
          <div className={styles.th}>{t('app.standard')}</div>
          <div className={styles.th}>{t('app.starter')}</div>
          <div className={styles.th}>{t('app.creator')}</div>
          <div className={styles.th}>{t('app.enterprise')}</div>
        </div>
        {features.map((row, idx) => (
          <div key={idx} className={styles.tr}>
            <div className={styles.td}>{row.name}</div>
            {row.vals.map((v, j) => (
              <div key={j} className={styles.td}>
                <div className={v === '✖' ? styles.tdclose : v === '✔' ? styles.tdopen : null}>
                  {' '}
                  {v == '✖' || v == '✔' ? '' : v}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingPage;
